interface SizeChipButtonProps {
  label: string;
  selected: boolean;
  soldOut: boolean;
  badge?: string;
  onSelect: () => void;
}

export function SizeChipButton({ label, selected, soldOut, badge, onSelect }: SizeChipButtonProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={soldOut}
      aria-pressed={selected}
      aria-label={soldOut ? `${label}, esgotado` : label}
      title={label}
      className={`relative min-h-[44px] min-w-[44px] px-3.5 py-1.5 rounded-lg border text-sm transition-colors flex flex-col items-center justify-center leading-tight focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate focus-visible:ring-offset-1 ${
        soldOut
          ? 'bg-champagne-light border-champagne-dark text-text-medium cursor-not-allowed'
          : selected
          ? 'bg-chocolate-dark text-white border-chocolate-dark font-semibold'
          : 'bg-white border-champagne-dark text-text-medium hover:border-chocolate'
      }`}
    >
      <span className={soldOut ? 'line-through' : undefined}>{label}</span>
      {soldOut && <span className="text-[11px] font-medium text-text-medium">Esgotado</span>}
      {!soldOut && badge && (
        <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-olivine/50 bg-olivine/15 px-2 py-px text-[10px] font-semibold leading-4 text-olivine-dark">
          {badge}
        </span>
      )}
    </button>
  );
}
